export const FORMS_ONE_PLATFORM_REPLACE_FORMS = 'FORMS_ONE_PLATFORM_REPLACE_FORMS';
export const FIELDS_ONE_PLATFORM_PATCH_FIELD =  'FIELDS_ONE_PLATFORM_PATCH_FIELD'